import { render, staticRenderFns } from "./BackendBoxed.vue?vue&type=template&id=4612be46&"
import script from "./BackendBoxed.vue?vue&type=script&lang=js&"
export * from "./BackendBoxed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports